import React, { Component } from 'react'

import $ from 'jquery'
import * as d3 from 'd3-3'
// import * as label from 'assets/svg/tree_label.svg'
import { SCREEN_THRESHOLD } from "global/constants";


export default class OgaTree extends Component {

    FULL_TREE;
    constructor(props) {
        super(props);
        this.state = {
            height: 400,
            width: 400
        };
        this.FULL_TREE = this.props.fullTree;
        this.isDesktop = window.innerWidth > SCREEN_THRESHOLD
    }

    componentDidUpdate(prevProps) {
        if (prevProps.searchname !== this.props.searchname) {
            this.onSearchUserChange(this.props.searchname);
        }

        if (prevProps.treeData !== this.props.treeData) {
            this.onTreeDataChange(this.props.treeData);
        }
    }

    /**
     * Helper function only used in the openTreeByUserId function
     */
    searchTree = (obj, search, path) => {
        if (obj.id === search) { //if search is found return, add the object to the path and return it
            path.push(obj);
            return path;
        }
        else if (obj.children || obj._children) { //if children are collapsed d3 object will have them instantiated as _children
            let children = (obj.children) ? obj.children : obj._children;
            for (let i = 0; i < children.length; i++) {
                path.push(obj);
                let found = this.searchTree(children[i], search, path);
                if (found) { return found; } else { path.pop(); }
            }
        }
        else {   //not the right object, return false so it will continue to iterate in the loop
            return false;
        }
    }

    /**
     * Helper function only used in the searchTree function
     */
    openPaths = (paths) => {
        for (let i = 0; i < paths.length; i++) {
            if (paths[i].id !== "1") {//i.e. not root
                paths[i].class = 'found redLink';
                if (paths[i]._children) { //if children are hidden: open them, otherwise: don't do anything
                    paths[i].children = paths[i]._children;
                    paths[i]._children = null;
                }
                // this.drawTheTreeBasedOnSourceObject(paths[i]);
            }
        }
    }

    onSearchUserChange = (selection) => {
        if (!selection || selection.length < 1) {
            return;
        }
        let id = selection[0].id;
        this.openTreeByUserId(id);
    };

    openTreeByUserId = (id) => {
        this.unsetRedLinks();
        let paths = this.searchTree(this.root, id, []);
        if (typeof (paths) !== "undefined") {
            this.openPaths(paths);
            this.drawTheTreeBasedOnSourceObject(this.root)
            let node = paths[paths.length - 1];
            this.centerNode(node);
            this.onSelectionChange(node);
        }
        else {
            alert(id + " not found!");
        }
    }

    onSelectionChange = (node) => {
        if (this.props.onSelectionChange) {
            this.props.onSelectionChange(node);
        }
    }

    /**
     * After rest call we call callD3
     * and expand all id it's a sale tree
     */
    serverSelection; // we retrieve this value in the drawTheTreeBasedOnSourceObject method
    onTreeDataChange = (data) => {
        $("#tree-container").html("");
        this.callD3(data);
        if (this.serverSelection) {
            this.selectAndCenterNodeToServerSelection(this.serverSelection);
            this.onSelectionChange(this.serverSelection)
        }
    }

    selectAndCenterNodeToServerSelection(d) {
        this.centerNode(d);
        this.addRedCircleToThisNodeAndRemoveToAllOthers(d)
    }

    componentDidMount() {
        // console.dir(d3);
    }

    x;
    y;
    scale;
    zoomListener;
    viewerWidth;
    viewerHeight;
    duration;
    tree;

    /**
     * Function to center node when clicked so node doesn't get lost when collapsing/moving with large amount of children
     */
    centerNode = (source) => {
        this.scale = this.zoomListener.scale();
        let x_ratio = 2 // this.FULL_TREE ? (this.viewerWidth > 756 ? 2.5 : 2) : 2; // Set center x axis for desktop view
        this.x = -source.y0;
        this.y = -source.x0;
        this.x = this.x * this.scale + this.viewerWidth / x_ratio;                       // Position in x of the center node
        this.y = this.y * this.scale + this.viewerHeight / (this.FULL_TREE ? 2.5 : 3.5); // Position in y of the center node
        d3.select('g').transition().duration(this.duration)
            .attr("transform", "translate(" + this.x + "," + this.y + ")scale(" + this.scale + ")");
        this.zoomListener.scale(this.scale);
        this.zoomListener.translate([this.x, this.y]);
    }

    zoomIn = () => {
        this.zoomListener.scale(this.scale * 1.8);
        this.zoomListener.translate([this.x, this.y]);
    }

    node;
    maxLabelLength = 0;
    svgGroup;
    i = 0;
    diagonal;
    root;
    /**
     * After rest call we call callD3
     * and expand all id it's a sale tree
     */
    callD3 = (treeData) => {
        if (!treeData) {
            throw new Error("d3.json()");
        }

        // Calculate total nodes, max label length
        let totalNodes = 0;

        // Misc. variables
        this.duration = 750;

        /**
         * The size of the tree container
         */
        let containerHeight = this.FULL_TREE ? window : ".oga-tree-sale";
        this.viewerWidth = $("#tree-container").width();
        this.viewerHeight = $(containerHeight).height();
        this.tree = d3.layout.tree().size([this.viewerHeight, this.viewerWidth]);

        /**
         * Define a d3 diagonal projection for use by the node paths (LINKS) later on
         */
        this.diagonal = d3.svg.diagonal().projection((d) => [d.x, d.y]);

        /**
         * Define the maxLabelLength
         * used to set the max distance between nodes in the Y axis
         * in the update function
         */
        this.visit(treeData, (d) => {
            totalNodes++;
            this.maxLabelLength = Math.max(d.name.length, this.maxLabelLength);

        }, function (d) {
            // Should return the child for the visit function to work
            return d.children && d.children.length > 0 ? d.children : null;
        });


        /**
         * Sort the tree by name
         */
        this.sortTree();

        /**
         * Define the zoomListener which calls the zoom function on the "zoom" event constrained within the scaleExtents
         * used in the function centerNode() too
         */
        this.zoomListener = d3.behavior.zoom().scaleExtent([0.1, 3]).on("zoom", this.zoom);

        /**
         * Define the base svg and attache the zoom behaviour
         */
        let baseSvg = d3.select("#tree-container").append("svg")
            // .attr("transform", "rotate(90)")
            .attr("width", this.viewerWidth)
            .attr("height", this.viewerHeight)
            .attr("class", "overlay")
            .call(this.zoomListener)
            .on("dblclick.zoom", null);

        /**
         *  Append a group which holds all nodes and which the zoom Listener can act upon
         */
        this.svgGroup = baseSvg.append("g");


        /**
         *  Define the root of the tree
         */
        this.root = treeData;
        this.root.x0 = this.viewerHeight / 2; //???
        this.root.y0 = 0;


        // Layout the tree initially and center on the root node.
        if(!this.props.isSale){
            this.expandAll(); 
            this.isDesktop ? this.collapseByDepth(this.root, 2) : this.collapseByDepth(this.root, 1);              
        }
        this.drawTheTreeBasedOnSourceObject(this.root);

        // this.centerNode(this.root);
    }

    // sort the tree according to the node names
    sortTree = () => {
        this.tree.sort((a, b) => b.id < a.id ? 1 : -1);
    };

    // Define the zoom function for the zoomable tree
    zoom = () => {
        this.svgGroup.attr("transform", "translate(" + d3.event.translate + ")scale(" + d3.event.scale + ")");
    };

    avoidCallingTwice = false;
    click = (d) => {
        console.log("Oga tree click", d);
        if (d3.event.defaultPrevented) return; // click suppressed

        if (this.avoidCallingTwice) return;


        if (this.FULL_TREE) {
            this.unsetRedLinks();
            this.addRedCircleToThisNodeAndRemoveToAllOthers(d);    //Add red circle
            if (this.selectedNode === d) {  // handle second click
                this.avoidCallingTwice = true;
                d = this.toggleChildren(d);
                this.drawTheTreeBasedOnSourceObject(d);

                setTimeout(() => {
                    this.avoidCallingTwice = false;
                }, 800);

            } else {
                console.log("Oga tree click", d);
                this.onSelectionChange(d);
            }
            this.centerNode(d);

            this.selectedNode = d;
        } else if (d.nodeType === "EMPTY_MINE") {

            this.addRedCircleToThisNodeAndRemoveToAllOthers(d);    //Add red circle
            this.centerNode(d);
            this.selectedNode = d;
            this.onSelectionChange(d);
        }


    }


    unsetRedLinks = () => {
        this.link.transition()
            .style("stroke", (d) => { if (d.target.class === "found redLink" || d.target.class === "redLink") { d.target.class = ""; } })
    }

    /**
     *  Open and close node
     */
    selectedNode;
    toggleChildren = (d) => {
        if (d.children) {
            d._children = d.children;
            d.children = null;
        } else if (d._children) {
            d.children = d._children;
            d._children = null;
        }
        return d;
    };


    /**
     *  A recursive helper function for performing some setup by walking through all nodes
     */
    visit = (parent, visitFn, childrenFn) => {
        if (!parent) return;

        visitFn(parent);

        let children = childrenFn(parent);
        if (children) {
            let count = children.length;
            for (let i = 0; i < count; i++) {
                this.visit(children[i], visitFn, childrenFn);
            }
        }
    }
expandAll
    expandAll = () => {
        this.expand(this.root);
        this.drawTheTreeBasedOnSourceObject(this.root);
    }

    collapseAll = () => {
        console.log("collapseAll");
        this.root.children.forEach((child) => {
            console.log("child", child, child.depth);            
            this.collapse(child);
        });        
        this.drawTheTreeBasedOnSourceObject(this.root);
    }

    collapseByDepth = (d, depth) => {        
        if (d.children) {            
            d._children = d.children;            
            d._children.forEach((x) => this.collapseByDepth(x,depth));
            if(d.depth >= depth){
                d.children = null;
            }
        }        
    }

    /**
     *  Helper functions for collapsing and expanding nodes.
     */
    collapse = (d) => {
        if (d.children) {
            console.log("d.children", d.children);
            console.log("d", d, d.depth);
            d._children = d.children;            
            d._children.forEach(this.collapse);
            d.children = null;
        }
    };

    expand = (d) => {
        if (d._children) {
            d.children = d._children;
            d.children.forEach(this.expand);
            d._children = null;
        }
    };

    isLeaf = (d) => !((d.children && d.children.length > 0) || (d._children && d._children.length > 0));

    /**
     *  Set up the levelWidth
     */
    childCount = (level, n) => {
        if (n.children && n.children.length > 0) {
            if (this.levelWidth.length <= level + 1) this.levelWidth.push(0);

            this.levelWidth[level + 1] += n.children.length;
            n.children.forEach((d) => {
                this.childCount(level + 1, d);
            });
        }
    };

    /**
     *  Set this node as selected in the view
     */
    addRedCircleToThisNodeAndRemoveToAllOthers = (d) => {
        d3.selectAll('.ghostCircle').attr('class', 'ghostCircle');
        d3.selectAll('.nodeCircle').attr('class', (e) => `${this.getClassNameDependOfType(e)}`);
        d3.select(d.underliningDomNode.parentNode).select('.nodeCircle').attr("class", (e) => `${this.getClassNameDependOfType(e)} nodeSelected`);
        d3.select(d.underliningDomNode.parentNode).select('.ghostCircle').attr('class', 'ghostCircle show');
    }

    /**
     *  Paint the node depending of its node type;
     */
    getClassNameDependOfType = (d) => {

        if (d.compress === 1) {
            return "nodeCircle node_compressed";
        }

        if (d.nodeType === 'EMPTY_MINE') {
            return "nodeCircle node_empty_mine";
        }

        if (d.nodeType === 'EMPTY_OTHER') {
            return "nodeCircle node_empty_other";
        }

        if (d.paid) {
            return "nodeCircle node_paid";
        }

        if (d.onTime) {
            return "nodeCircle node_seller";
        }

        if (d.defeated) {
            return "nodeCircle node_prospect";
        }

        if (d.inExecution) {
            return "nodeCircle node_inactive";
        }

        if (d.reverted) {
            return "nodeCircle node_reverted";
        }

        return "nodeCircle node_seller";

    }


    link;
    levelWidth = [1];
    /**
     *  draw the tree by passing the source object
     */
    drawTheTreeBasedOnSourceObject = (source) => {

        console.log("here");
        console.dir(source);

        let self = this;

        self.levelWidth = [1];

        /**
         *  The distance in X and Y between nodes
         */
        let X_DISTANCE_BETWEEN_NODES = 125;
        let Y_DISTANCE_BETWEEN_NODES = 4;
        let NODE_RADIUS_SIZE = 24;
        let SELECTED_NODE_RADIUS_SIZE = NODE_RADIUS_SIZE*2;
        let IMAGE_SIZE = 45;
        let BLEND_MODE = "normal"; //"hard-light"
        let LABEL_SPACING = 30;
        let LABEL_ROTATION = -25;
        /**
         *  Set up the levelWidth array needed to size the tree
         */
        self.childCount(0, self.root);
        let newHeight = d3.max(self.levelWidth) * X_DISTANCE_BETWEEN_NODES; // 25 pixels per line
        self.tree = self.tree.size([newHeight, self.viewerWidth]);

        /**
         *  Compute the nodes and links array objects
         */
        let localNodes = self.tree.nodes(self.root).reverse(),
            links = self.tree.links(localNodes);

        /**
         *  Set the distance between nodes
         */
        localNodes.forEach((d) => d.y = (d.depth * (self.maxLabelLength * Y_DISTANCE_BETWEEN_NODES)));

        // Update the nodes…
        /**
         *  ???
         */
        self.nodes = self.svgGroup.selectAll("g.node").data(localNodes, (d) => d.id || (d.id = ++self.i));

        // Enter any new nodes at the parent's previous position.
        /**
         *  Set the each node <g> tag to it's parent position
         *  Define click handler for each node
         *  Add the SVG node dom element to the object for easier manipulation
         */
        let nodeEnter = self.nodes.enter().append("g")
            .attr("class", "node")
            .attr("transform", (d) => "translate(" + source.y0 + "," + source.x0 + ")")
            .on('click', function (d) { self.click(d, this) });


        /**
         *  Draw each node as a circle
         *  and assign the class "nodeCircle" + another css class based on it type
         */
        nodeEnter.append("circle")
            .attr('class', (d) => self.getClassNameDependOfType(d))
            .attr("r", 0);

        /**
         *  Draw the name of the user representing by it's node
         */
        nodeEnter.append("text")
            .attr("x", (d) => self.isLeaf(d) ? -LABEL_SPACING : LABEL_SPACING)
            .attr("transform", `rotate(${LABEL_ROTATION})`)
            .attr("dy", ".35em")
            .attr('class', 'nodeText')
            .attr("text-anchor", (d) => self.isLeaf(d) ? "end" : "center")
            .text((d) => d.name)
            .style("fill-opacity", 0);


        /**
         *  Set up all ghostCircle in an hidden state
         *  which will be reveal (by adding the class show) if the node is selected
         */
        nodeEnter.append("circle")
            .attr('class', 'ghostCircle')
            .attr("r", SELECTED_NODE_RADIUS_SIZE)
            .attr("opacity", 0.2); // change this to zero to hide the target area

        /**
         *  Update the text to reflect whether node has children or not
         */
        self.nodes.select('text')
            .attr("x", (d) => self.isLeaf(d) ? -LABEL_SPACING : LABEL_SPACING)
            .attr("text-anchor", (d) => self.isLeaf(d) ? "end" : "start")
            .text((d) => d.compress === 1 ? '' : d.name);


        /**
         *  Set the radius of each node
         */
        let found = false;
        self.nodes.select("circle.nodeCircle")
            .attr("r", (d) => d.compress === 1 ? 15 :  NODE_RADIUS_SIZE)
            .style("class", function (d) {
                // And circle selection when the user search from the search bar
                // The selected node is the first in the loop so we add the style only to the first
                if (d.selected) {
                    self.serverSelection = d;
                }
                d.underliningDomNode = this;
                if (d.class === "found redLink" && !found) {
                    if (!found) {
                        self.addRedCircleToThisNodeAndRemoveToAllOthers(d);
                        found = true;
                    }
                    d.class = 'redLink'; // remove the class older to avoid painting circle in next iteration
                }
            });


        // Transition nodes to their new position.
        /**
         *  Animate each node to it position
         *  The actual position of each node are set during the animation
         */
        let nodeUpdate = self.nodes.transition()
            .duration(self.duration)
            .attr("transform", (d) => "translate(" + d.x + "," + d.y + ")" /* This change the position of the circles */);

        // Fade the text in
        nodeUpdate.select("text").style("fill-opacity", 1);

        // Transition exiting nodes to the parent's new position.
        /**
         *  The animation for nodes (not links) while collapsing
         */
        let nodeExit = self.nodes.exit().transition()
            .duration(self.duration).attr("transform", (d) => "translate(" + source.x + "," + source.y + ")" /* changed x y */).remove();
        nodeExit.select("circle").attr("r", 0);
        nodeExit.select("text").style("fill-opacity", 0);

        // Update the links…
        self.link = self.svgGroup.selectAll("path.link").data(links, (d) => d.target.id);

        // Enter any new links at the parent's previous position.
        /**
         *  Draw the links
         */
        self.link.enter().insert("path", "g")
            .attr("class", "link")
            .attr("d", (d) => {
                let o = {
                    y: source.x0,
                    x: source.y0   //Changed xy
                };
                return self.diagonal({
                    source: o,
                    target: o
                });
            });

        /**
         *  Transition links to their new position
         *  and assign style
         */
        self.link.transition()
            .duration(self.duration)
            .style("stroke", function (d) {
                /**
                 *  Draw the link as red if found from openTreeByUserId
                 */
                if (d.target.class && d.target.class.includes("redLink")) {
                    return "#ff4136";
                }
            })
            .attr("d", self.diagonal);


        /**
         *  Collapse links to their parent position
         *  called when user click twice (for closing the tree)
         */
        self.link.exit().transition()
            .duration(self.duration)
            .attr("d", (d) => {
                let o = { x: source.x, y: source.y }; // Should not be changes
                return self.diagonal({ source: o, target: o });
            }).remove();


        nodeEnter.append("svg:image")
            .attr("xlink:href", (d) => `data:image/png;base64,${d.image}`)
            .attr("x", function(d) { return -(d.compress === 1 ? 13.5 : IMAGE_SIZE /2);})
            .attr("y", function(d) { return -(d.compress === 1 ? 13.5 : IMAGE_SIZE /2);})
            .style('mix-blend-mode', BLEND_MODE)
            .attr("height", function(d) { return (d.compress === 1 ? 27.5 : IMAGE_SIZE);})
            .attr("width", function(d) { return (d.compress === 1 ? 27.5 : IMAGE_SIZE);})
            .attr("clip-path", "url(#clip-circle)");
        // Stash the old positions for transition.
        /**
         *  ???
         */
        localNodes.forEach(function (d) {
            d.x0 = d.y;
            d.y0 = d.x;
        });
    }

    render() {
        return (
            <div id={`tree-container`} className="w-100 block" />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/OgaTree/OgaTree.jsx